export class WorkflowAccessError extends Error {
  constructor(
    message: string,
    readonly code?: 'workflow_disabled_for_workspace' | 'workflow_unavailable',
  ) {
    super(message);
  }
}

/** Preserve unrelated error responses for each caller's existing error handling. */
export async function throwIfWorkflowAccessError(response: Response): Promise<void> {
  if (response.status !== 403 && response.status !== 503) return;
  const problem = await response
    .clone()
    .json()
    .catch(() => null);
  if (!problem || typeof problem !== "object") return;
  const code = problem.code ?? problem.error;
  const retired = response.status === 403 && code === "workflow_disabled_for_workspace";
  const unavailable = response.status === 503 && code === "workflow_unavailable";
  if (!retired && !unavailable) return;
  const detail = problem.detail ?? problem.message;
  throw new WorkflowAccessError(
    typeof detail === "string" && detail
      ? detail
      : retired
        ? "This workflow has been retired for your workspace."
        : "Workflow access is temporarily unavailable. Please try again.",
    retired ? 'workflow_disabled_for_workspace' : 'workflow_unavailable',
  );
}
